import axios from 'axios'

import { tagCrmError } from '../utils/error-message'

const PipefyWrapper = {
  requestToPipefy: (accessToken, payload) => {
    return new Promise((resolve, reject) => {
      const url = 'https://api.pipefy.com/graphql'
      const headers = {
        'Content-Type': 'application/json',
        authorization: `Bearer ${accessToken}`
      }
      return axios.post(url, payload, { headers }).then(({ data }) => {
        if (data && data.errors && data.errors.length > 0) {
          data.message = data.errors.reduce((message, error, index) => {
            if (index > 0) return `${message}, ${error.message}`
            return error.message
          }, '')
          return reject(tagCrmError(data))
        } else return resolve(data.data)
      }).catch(err => {
        // TEL-2243: em erro de rede (timeout, DNS, TLS) nao ha `response`, e a
        // desestruturacao estourava TypeError antes de marcar o erro do CRM.
        const data = err && err.response && err.response.data
        return reject(tagCrmError(data || err))
      })
    })
  },
  checkAccessToken: (accessToken) => {
    return new Promise((resolve, reject) => {
      const payload = {
        query: `{
          me {
            id
          }
        }`
      }
      return PipefyWrapper.requestToPipefy(accessToken, payload).then(({ me }) => {
        if (me && me.id) return resolve(true)
        return resolve(false)
      }).catch(err => {
        return reject(tagCrmError(err))
      })
    })
  }
}

export default PipefyWrapper



// WEBPACK FOOTER //
// ./src/services/pipefy-wrapper.js